import { render, staticRenderFns } from "./HumanIcon.vue?vue&type=template&id=42457af4&"
import script from "./HumanIcon.vue?vue&type=script&lang=js&"
export * from "./HumanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports